import { authService } from '@/plugins/vue-auth.ts';
import { redirectToFirstAvailableFlowRoute } from '@/mixins/Flows.js';
import Division from '../entities/Division.js';

export default [
    {
        path: '/flow',
        name: 'flow',
        component: { template: '<div></div>' },
        beforeEnter: async () => {
            if (!authService.ready()) {
                await authService.waitForUser();
            }

            return redirectToFirstAvailableFlowRoute();
        },
    },
    {
        path: '/flow/web-boost',
        name: 'flow.webBoost',
        component: () => import(/* webpackChunkName: "flow" */ '../views/Flow/WebBoost.vue'),
        meta: {
            fixedContent: true,
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                division: [Division.NEW, Division.USED, Division.FINANCE, Division.SERVICE],
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
    {
        path: '/flow/phone-up',
        name: 'flow.phoneUp',
        component: () => import(/* webpackChunkName: "flow" */ '../views/Flow/PhoneUp.vue'),
        meta: {
            fixedContent: true,
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                division: [Division.NEW, Division.USED, Division.SERVICE],
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
    {
        path: '/flow/lead-xpress',
        name: 'flow.leadXpress',
        component: () => import(/* webpackChunkName: "flow" */ '../views/Flow/LeadXpress.vue'),
        meta: {
            fixedContent: true,
            accountSelect: {
                disabled: false,
                showParentAccounts: false,
            },
            header: {
                account: true,
                division: [Division.NEW, Division.USED, Division.FINANCE, Division.SERVICE],
                notification: true,
                search: true,
                settings: true,
            },
            saveInUrl: ['accountId'],
        },
    },
];
